import { PollScheduler } from "../../../core/utils/poll-scheduler"

const IN_APP_COMMS_POLL_INTERVAL_SECS = 30 * 60

let inAppCommsPoller: PollScheduler | null = null

export function startInAppCommsPoller(task: () => void): void {
    if (inAppCommsPoller?.getIsRunning()) return
    inAppCommsPoller = new PollScheduler(task, [IN_APP_COMMS_POLL_INTERVAL_SECS])
    inAppCommsPoller.start()
}

export function stopInAppCommsPoller(): void {
    inAppCommsPoller?.cancel()
    inAppCommsPoller = null
}
